/**
 * Campaign mappings, landing-page copy, and client logos.
 *
 * Split out of utils/Constants.js (roadmap Module 8) — Constants.js remains
 * a re-export shim until import sites migrate to "src/constants/marketing".
 */
// Client logos
import MaraLogo from "src/images/mara.png";
import LattizoriLogo from "src/images/lattizori.png";
import PresenceLogo from "src/images/presence.png";
import RanavatLogo from "src/images/ranavat.png";
import FamilyTimesLogo from "src/images/family-time.png";

export const suggestionBtnsLandingPage = [
  {
    text: "Draft customer contract",
  },
  {
    text: "Start a company",
    func: "Review",
  },

  {
    text: "Review redlines",
  },
  {
    text: "Protect my IP",
  },
];

export const WELCOME_MESSAGES = [
  {
    id: "welcome-lawyer",
    message_type: "welcome_lawyer",
    is_user_message: false,
    payload: {
      text: "",
    },
  },
];

export const FIRST_VISIT_ACTIONS = [
  // { id: "action-1", title: "Loop in your lawyer", subtitle: "Click to discover what Max can do for you", prompt_text: "I want to loop in a lawyer for legal advice", icon: "avatar" },
  { id: "action-2", title: "Review a legal document", subtitle: "Upload a document and get detailed AI feedback based on industry best practices", prompt_text: "Review a legal document", icon: "list", iconColor: "#7418EC", iconBg: "#F5F3F7", iconBorder: "#DDD6FE" },
  { id: "action-3", title: "Draft a legal document", subtitle: "Generate a draft of any contract, letter, or court document - accurately and quickly", prompt_text: "Draft a contract", icon: "file", iconColor: "#186DEC", iconBg: "#F3F4F7", iconBorder: "#BFDBFE" },
  { id: "action-4", title: "Research a legal issue", subtitle: "Ask any legal question and get practical self-help guidance and expert strategy", prompt_text: "Research a legal issue", icon: "search", iconColor: "#18B447", iconBg: "#F3F7F4", iconBorder: "#A1E3B5" },
];

export const campaignNameToDetailMappings = {
  testask: "Draft a Test Ask",
  nda: "NDA",
  termsofservice: "Draft a Terms of Service",
  privacypolicy: "Draft a Privacy Policy",
  partnershipagreement: "Draft a Partnership Agreement",
  shareholderagreement: "Draft a Shareholder Agreement",
};

export const campaignUtmSourceMappings = {
  testask: "test-ask",
  testdraft: "test-draft",
  sd_inhouseapp_search_trypage_employeeagreement_us_march2025: "employment-agreement",
  sd_inhouseapp_search_employeeagreement_us_march2025: "employment-agreement",
  sd_inhouseapp_search_trypage_ic_agreement_us_march2025: "ic-agreement",
  sd_inhouseapp_search_trypage_msa_us_march2025: "msa",
  sd_inhouseapp_search_trypage_partnershipagreement_us_march2025: "partnership-agreement",
  sd_inhouseapp_search_trypage_shareholderagreement_us_march2025: "shareholder-agreement",
  22771289011: "employment-contract",
  22771275019: "business-license-online-business",
  22771289038: "small-business-tax-loopholes",
  22771275040: "firing-an-employee",
  22771275013: "business-license",
  22771289026: "mutual-confidentiality-agreement",
  22771289035: "llc-partnership-taxes",
  22771275037: "severance-negotiation",
  22771289032: "msa-template",
  22771289029: "mutual-nda-template",
  22771289023: "mutual-nda-and-confidentiality-agreement",
  22771275034: "earn-outs",
  22771275031: "commercial-lease-negotiation",
  22771275028: "get-out-of-commercial-lease",
  22771289017: "business-partnership-agreement",
  22771289014: "loan-agreements",
  22771275025: "lease-review-lawyer",
  22771275022: "business-license-to-sell-online",
  22771275016: "permit-online-business",
  22771289020: "partnership-agreements",
};

export const prefillMappings = {
  "employment-contract": "Help with an employment contract",
  "business-license-online-business": "Do I need a business license to sell online?",
  "small-business-tax-loopholes": "Help with small business tax strategies",
  "firing-an-employee": "Help with firing an employee",
  "business-license": "Help with getting a business license",
  "mutual-confidentiality-agreement": "Help with a mutual confidentiality agreement",
  "llc-partnership-taxes": "Help with filing LLC partnership taxes",
  "severance-negotiation": "Help with severance negotiation",
  "msa-template": "Help with a non-disclosure agreement (NDA)",
  "mutual-nda-template": "Help with a mutual non-disclosure agreement",
  "mutual-nda-and-confidentiality-agreement": "Help with a mutual NDA & confidentiality agreement",
  "earn-outs": "Help with earn-out contracts",
  "commercial-lease-negotiation": "Help with commercial lease negotiation",
  "get-out-of-commercial-lease": "Help getting out of a commercial lease",
  "business-partnership-agreement": "Help with a business partnership agreement",
  "loan-agreements": "Help with a loan agreement",
  "lease-review-lawyer": "Help reviewing a lease agreement",
  "business-license-to-sell-online": "Do I need a business license for an online business?",
  "permit-online-business": "Do I need a permit to run an online business?",
  "partnership-agreements": "Help with a partnership agreement",
};

export const marketingPromptMappings = {
  "draft-this-contract": "Create a customer agreement with seller friendly late fees, renewal language, and termination clause.",
  "onboard-employee": "Prepare an offer letter, IP assignment, NDA, and onboarding checklist for a new hire.",
  "send-a-demand-letter": "Draft a demand letter for an overdue invoice, referencing the contract and outlining next steps.",
  "collect-invoice": "A customer hasn’t paid my invoice. Help me collect what I’m owed.",
  "review-lease-negotiation": "Review my commercial lease and identify any terms I should negotiate before signing.",
  "draft-privacy-policy-toc": "Draft a Privacy Policy and Terms of Service for my website.",
  "employee-handbook": "Create an employee handbook tailored to my business, industry, and employees.",
  "review-contractor-agreement": "Review a contractor agreement and recommend changes that better protect me if the work is delayed, over budget, or incomplete.",
  "personal-loan-agreement": "Create a personal loan agreement for money I’m lending to a family member, including repayment terms and what happens if they miss a payment.",
  "lease-agreement": "Look at a lease agreement and explain any terms I should negotiate or understand before I sign.",
  "nanny-agreement": "Draft a nanny agreement that includes work hours, pay, responsibilities, time off, and confidentiality provisions.",
};

export const campaignIdMappings = {
  testdraft: "recML9wVs9dseQ52c",
  sd_inhouseapp_search_trypage_employeeagreement_us_march2025: "reck1iUWfzg3FblCr",
  sd_inhouseapp_search_employeeagreement_us_march2025: "reck1iUWfzg3FblCr",
  nda: "others",
  termsofservice: "others",
  privacypolicy: "others",
  sd_inhouseapp_search_trypage_ic_agreement_us_march2025: "rec6iawmiLFxfvRX2",
  sd_inhouseapp_search_trypage_msa_us_march2025: "recwLxd3OSlhdNxQi",
  sd_inhouseapp_search_trypage_partnershipagreement_us_march2025: "others",
  sd_inhouseapp_search_trypage_shareholderagreement_us_march2025: "others",
  22771289011: "22771289011",
  22771275019: "22771275019",
  22771289038: "22771289038",
  22771275040: "22771275040",
  22771275013: "22771275013",
  22771289026: "22771289026",
  22771289035: "22771289035",
  22771275037: "22771275037",
  22771289032: "22771289032",
  22771289029: "22771289029",
  22771289023: "22771289023",
  22771275034: "22771275034",
  22771275031: "22771275031",
  22771275028: "22771275028",
  22771289017: "22771289017",
  22771289014: "22771289014",
  22771275025: "22771275025",
  22771275022: "22771275022",
  22771275016: "22771275016",
  22771289020: "22771289020",
  22786057181: "22786057181",
};

export const CLIENT_LOGOS = [
  { src: MaraLogo, alt: "MARA", className: "h-8" },
  { src: LattizoriLogo, alt: "Lattizori", className: "h-8" },
  { src: PresenceLogo, alt: "Presence", className: "h-8" },
  { src: RanavatLogo, alt: "Ranavat", className: "h-8" },
  { src: FamilyTimesLogo, alt: "Family Times", className: "h-10" },
];
